<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="purchaseAirlinesObj.isActive ? 'tag is-success' : 'tag'"
        >Standard rule</span
      >
      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">Airline is not a preferred vendor</p>
          <p>
            Trigger when the airline is not a preferred vendor
            <u> {{ purchaseAirlinesObj.value }} </u>
          </p>
        </div>
        <div class="allbtns">
          <b-switch
            :rounded="true"
            :value="purchaseAirlinesObj.isActive"
            v-model="purchaseAirlinesObj.isActive"
            @input="airPreferredVendor"
            :left-label="true"
          >{{ purchaseAirlinesObj.isActive ? 'Active' : 'Inactive' }}
          </b-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    value: {
      type: [Object],
    },
  },
  data() {
    return {
      purchaseAirlinesObj: this.value
        ? this.value
        : {
            name: "airPreferredVendor",
            isActive: false,
            type: "air",
            message: "",
          },
    };
  },
  methods: {
    airPreferredVendor() {
      this.$emit("airPreferredVendor", this.purchaseAirlinesObj);
    },
  },
  mounted() {
    this.purchaseAirlinesObj.type = "air";
    this.purchaseAirlinesObj.message = this.buildMessage;
    this.$emit("airPreferredVendor", this.purchaseAirlinesObj);
  },
  computed: {
    buildMessage() {
      var string = "Airline is not a preferred vendor";

      return string;
    },
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.purchaseAirlinesObj = this.value;
        this.purchaseAirlinesObj.type = "air";
    this.purchaseAirlinesObj.message = this.buildMessage;
    this.$emit("airPreferredVendor", this.purchaseAirlinesObj);

      },
      deep: true,
    },
  },
};
</script>
